import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const TaxbillList = ({
  dashboard,
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  handleCellEditable,
}) => {
  const [pageSize, setPageSize] = React.useState(20);
  const [height, setHeight] = React.useState("calc(100vh - 280px)");

  React.useEffect(() => {
    if (dashboard) {
      setHeight('350px')
    }
  }, [dashboard])


  return (

    <div style={{ display: 'flex', height: height }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '계산서_리스트' },
          }}
          isCellEditable={handleCellEditable}
          loading={loading}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
        
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
        />
      </div>
    </div>
  );
};

export default TaxbillList;
